import axios
    from "axios";
import API_URL from "../constant/api.config";
import { isEmpty, trim } from "lodash";
import { setAuthHeaders } from "../utils/common";
import axiosInstance from '../axiosHttp';

export const roleList = () => async (dispatch) => {
    return await axios.get(API_URL + '/roles').then((response) => {
        dispatch({
            type: 'LIST_ROLES',
            payload: response.data
        });
        return response.data;
    }).catch((err) => {
        console.log("Error ======== ", err);
    });
}

export const getRoleList = (offset, limit, columnName, sortDirection, searchTxt = null) => async (dispatch) => {

    searchTxt = trim(searchTxt);
    searchTxt = btoa(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);

    return await axios.get(API_URL + '/role-list/' + offset + '/' + limit + '/' + columnName + '/' + sortDirection + searchQueryString
    ).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const createRole = (data) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + '/create-role', data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const updateRole = (data) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + '/update-role', data, { headers }).then((response) => {
        // console.log(" API response in userAction File ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const deleteRole = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/delete-role/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

